import Modal from "../components/main/Modal";
import React, {ChangeEvent} from "react";
import BundledEditor from '../components/BundledEditor'
import Button from "../components/element/Button";
import Input from "../components/element/Input";
import EntityApi from "../api/EntityApi";
import InputFile from "../components/element/InputFile";
import InputFileMultiple from "../components/element/InputFileMultiple";
import FileApi from "../api/FileApi";
import config from "../api/config";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowCircleDown, faArrowCircleUp, faArrowCircleLeft, faArrowCircleRight, faRemove} from "@fortawesome/free-solid-svg-icons";
import { Radio, Flex, Select } from "antd";
import IconMaterial from "../components/element/IconMaterial";
import {StopOutlined} from "@ant-design/icons";

const FormSlideshow = ({setContentData, value}) => {

    const [ contentFiles, setContentFiles] = React.useState([]);
    const [isClear, setClear] = React.useState(false);
    const [isLoading, setLoading ] = React.useState(false);

    const isJsonValid = (str) => {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }

    const handleFile = (e) => {
        if (e.target.files === null) {
            return
        }
        const formFiles = e.target.files

        if (formFiles) {
            setLoading(true);
            setClear(!isClear);
            FileApi.postMultiple(formFiles).then((data) => {
                if (data.status === 'success' && data.content.items[0].length > 0) {
                    let tmpContentFiles = [];
                    if (value !== '') {
                        tmpContentFiles = JSON.parse(value).map((value) => {
                            return value;
                        });
                    }
                    data.content.items[0].forEach((item) => {
                        tmpContentFiles.push(item.url);
                    })
                    setContentData(JSON.stringify(tmpContentFiles));
                    //setUrl(data.content.item.url);
                }
                setLoading(false);
            }).catch((error) => {
                alert('Ошибка сервер: ' + error);
            });
        }
    }


    function array_move(arr, old_index, new_index) {
        if (new_index >= arr.length) {
            var k = new_index - arr.length + 1;
            while (k--) {
                arr.push(undefined);
            }
        }
        arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
        return arr; // for testing
    }

    const moveLeft = (index) => {
        let tmpContentFiles = [];
        if (value !== '') {
            tmpContentFiles = JSON.parse(value).map((value) => {
                return value;
            });
        }
        if (index > 0) {
            let newIndex = index - 1;
            tmpContentFiles = array_move(tmpContentFiles, index, newIndex);
            //setContentFiles(tmpContentFiles);
            setContentData(JSON.stringify(tmpContentFiles));
            //setContentData(tmpContentFiles);
        }
    }

    const moveRight = (index) => {
        let tmpContentFiles = [];
        if (value !== '') {
            tmpContentFiles = JSON.parse(value).map((value) => {
                return value;
            });
        }
        let newIndex = index + 1;
        tmpContentFiles = array_move(tmpContentFiles, index, newIndex);
        //setContentFiles(tmpContentFiles);
        setContentData(JSON.stringify(tmpContentFiles));
        //setContentData(tmpContentFiles);
    }

    const remove = (index) => {
        let tmpContentFiles = [];
        if (value !== '') {
            tmpContentFiles = JSON.parse(value).map((value) => {
                return value;
            });
        }
        tmpContentFiles.splice(index, 1);
        setContentData(JSON.stringify(tmpContentFiles));
    }

    React.useEffect(() => {
        //console.log('slideshow');
    }, [])

    return <div className={"rounded-lg border border-slate-300 relative"} style={{width: '910px', minHeight: '300px', padding: '1rem'}}>
        {
            isLoading &&
            <div className="app-preloader absolute opacity-50 z-50 grid h-full w-full place-content-center bg-slate-50 dark:bg-navy-900">
                <div className="app-preloader-inner relative inline-block h-48 w-48"></div>
            </div>
        }
        <div className="pb-3 block">
            <div>
                <div className={"flex place-content-center "}>
                    <InputFileMultiple isClear={isClear} onChange={handleFile}/>
                </div>
                <div className={"flex flex-wrap place-content-center mt-6"}>
                    {
                        value !== '' && isJsonValid(value) && JSON.parse(value).map((value, index) => {
                            return <div className={'relative'} key={index} style={{marginRight: "1rem", marginBottom: "1rem"}}>
                                <div className={'absolute'} style={{top: 0, right: 0, opacity: '0.8'}}>
                                    <Button  onClick={() => remove(index)} text={<FontAwesomeIcon icon={faRemove}/>} type={'errorSmall'}/>
                                </div>
                                <img src={value}  style={{maxHeight: "150px", height: "150px"}}  alt={"1"}/>
                                <div className={"flex"} style={{paddingTop: "0.5rem"}}>
                                    <div className={"w-full"} style={{marginRight: "5px"}}>
                                        {
                                            index > 0 ?
                                            <Button onClick={() => moveLeft(index)} text={<FontAwesomeIcon icon={faArrowCircleLeft}/>}  type={"info"}/>
                                                :
                                                <></>
                                        }
                                    </div>
                                    <div className={"w-full"}>
                                        {
                                            index < value.length - 1 ?
                                                <Button onClick={() => moveRight(index)} text={<FontAwesomeIcon icon={faArrowCircleRight}/>}  type={"info"}/>
                                                :
                                                <></>
                                        }
                                    </div>
                                </div>
                            </div>
                        })
                    }
                </div>
            </div>
        </div>
    </div>
}
const FormFile = ({setContentData, value}) => {

    const [fileName, setFileName] = React.useState('');
    const [fileUrl, setFileUrl] = React.useState('');
    const [formFile, setFormFile] = React.useState();
    const [isLoading, setLoading ] = React.useState(false);
   /* const [ url, setUrl ] = React.useState(null);

    React.useEffect(() => {
        setUrl(value);
    }, []);

    React.useEffect(() => {
        setUrl(value);
    }, [value]);*/

    const handleFile = (e) => {
        if (e.target.files === null) {
            return
        }
        const formFile = e.target.files[0]
        if (formFile) {
            setLoading(true);
            FileApi.post(formFile).then((data) => {
                if (data.status === 'success') {
                    setContentData(data.content.item.url);
                    //setUrl(data.content.item.url);
                }
                setLoading(false);
            });
        }
    }

    const getExt = (name) => {
        console.log(name);
        var re = /(?:\.([^.]+))?$/;
        return re.exec(name)[1];
    }

    return <div className={"rounded-lg border border-slate-300"} style={{width: '910px', minHeight: '300px', padding: '1rem'}}>
        <div className="pb-3 block">
            {
                isLoading &&
                <div className="app-preloader absolute opacity-50 z-50 grid h-full w-full place-content-center bg-slate-50 dark:bg-navy-900">
                    <div className="app-preloader-inner relative inline-block h-48 w-48"></div>
                </div>
            }
            <div>
                <div className={"flex place-content-center "}>
                    <InputFile onChange={handleFile}/>
                </div>
                <div className={"flex place-content-center mt-6"}>
                    { value && (getExt(value) === 'jpg' || getExt(value) === 'jpeg' || getExt(value) === 'png') && <img style={{maxHeight: "250px"}} src={value}/>}
                    { value && getExt(value) === 'mp4' && <video controls><source src={value} type={"video/mp4"} /></video>}
                    { value && getExt(value) === 'pdf' && <div>PDF файл: <a style={{textDecoration: 'underline'}} href={value} target={"_blank"} >{value}</a></div> }
                    {
                        value &&
                        (getExt(value) !== 'pdf' && getExt(value) !== 'mp4' && getExt(value) !== 'jpg' && getExt(value) !== 'png' && getExt(value) !== 'jpeg')
                        && <div>Файл: <a style={{textDecoration: 'underline'}} href={value} target={"_blank"} >{value}</a></div> }
                </div>
            </div>
        </div>
    </div>
}

const FormText = ({setContentData, value}) => {
    return <textarea className={"rounded-lg border border-slate-300"} style={{width: '910px', height: '500px', padding: '1rem'}} value={value} onChange={(evt) => setContentData(evt.target.value)} />
}

const FormHtml = ({setEditor, value}) => {

    const editorRef = React.useRef(null);
   React.useEffect(() => {
       setEditor(editorRef);
    }, [])

    return <>
        <BundledEditor
            onInit={(_evt, editor) => editorRef.current = editor}
            initialValue={value}
            init={{
                height: 500,
                menubar: false,
                images_upload_url: config.host + '/api/editor/file',
                plugins: [
                    'advlist', 'anchor', 'autolink', 'help', 'image', 'link', 'lists',
                    'searchreplace', 'table', 'wordcount'
                ],
                toolbar: 'undo redo | blocks | image ' +
                    'bold italic forecolor | alignleft aligncenter ' +
                    'alignright alignjustify | bullist numlist outdent indent | ' +
                    'removeformat | help',
                content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
            }}
        />
    </>
}

const MaterialCreateFormModal = ({isOpen, onClose, onSuccess, chapterId, productId, type, materialId}) => {

    const [ isInModalData, setIsInModalData ] = React.useState(true);
    const [ isTitleHideData, setTitleHideData ] = React.useState(false);
    const [ titleData, setTitleData ] = React.useState('');
    const [ customType, setCustomType ] = React.useState('default');
    const [ contentData, setContentData ] = React.useState('');
    const [ editor, setEditor ] = React.useState(null);
    const [title, setTitle] = React.useState('Добавить материал');

    const onSuccessRequest = () => {
        if (onSuccess) {
            onSuccess();
        }
        setContentData('');
        setTitleData('');
        setIsInModalData(true);
        onClose();
    }

    const sendDataForm = () => {
        let content = contentData;
        if (type === 'html' && editor && editor.current) {
            content = editor.current.getContent();
        }

        if (materialId > 0) {

            if (titleData === '') {
                alert('Введите заголовок материала');
                return false;
            }

            EntityApi.post('private/material', materialId,{
                title: titleData,
                chapter: chapterId,
                product: productId,
                type: type,
                content: content,
                is_modal: isInModalData,
                is_hide_title: isTitleHideData,
                custom_type: customType,
            }).then((data) => {
                if (data.status == 'success') {
                    onSuccessRequest();
                    if (type === 'html' && editor && editor.current) {
                        editor.current.resetContent('');
                    }
                } else {
                    alert('Ошибка добавления нового материала');
                }
            })
        } else {

            if (titleData === '') {
                alert('Введите заголовок материала');
                return false;
            }

            EntityApi.put('private/material', {
                title: titleData,
                chapter: chapterId,
                product: productId,
                type: type,
                content: content,
                is_modal: isInModalData,
                custom_type: customType,
            }).then((data) => {
                if (data.status == 'success') {
                    onSuccessRequest();
                    if (type === 'html' && editor && editor.current) {
                        editor.current.resetContent('');
                    }
                } else {
                    alert('Ошибка добавления нового материала');
                }
            })
        }
    }

    React.useEffect(() => {

        setContentData('');
        setTitleData('');
        setIsInModalData(true);
        setTitle('Добавить материал');
        setCustomType('default');

        if (materialId > 0) {
            setTitle('Редактировать материал');
            EntityApi.get('private/material', materialId).then((data) => {
                if (data.status === 'success') {

                    setTitleData(data.content.item.title);
                    setIsInModalData(data.content.item.in_modal);
                    setTitleHideData(data.content.item.is_hide_title);
                    if (data.content.item.custom_type) {
                        setCustomType(data.content.item.custom_type);
                    }
                    if (data.content.item.type === 'html') {
                        setContentData(data.content.item.html);
                    }
                    if (data.content.item.type === 'text' || data.content.item.type === 'code') {
                        setContentData(data.content.item.text);
                    }
                    if (data.content.item.type === 'image' ||
                        data.content.item.type === 'file' ||
                        data.content.item.type === 'pdf' ||
                        data.content.item.type === 'video') {
                        setContentData(data.content.item.url);
                    }
                    if (data.content.item.type === 'slideshow') {
                        setContentData(data.content.item.url);
                    }

                } else {
                    materialId = 0;
                    setTitle('Добавить материал');
                }
            })
        }
    }, [materialId])

    return <Modal
        isOpen={isOpen}
        onClose={onClose}
        onSuccess={onSuccessRequest}
        title={title}
        component={
        <>
            <div className={"flex"}>
                <div className={"w-full"}>
                    <Input type={"text"} value={titleData} placeholder={"Введите заголовок материала"} onChange={setTitleData}  />
                </div>
            </div>
            <div className={"flex mt-3"}>

                <div className={"w-3/12 ml-4 flex"}>
                    <label className="inline-flex items-center space-x-2">
                        <input
                            onChange={() => setIsInModalData(!isInModalData)}
                            className="form-switch h-5 w-10 rounded-full bg-slate-300 before:rounded-full before:bg-slate-50 checked:bg-primary checked:before:bg-white dark:bg-navy-900 dark:before:bg-navy-300 dark:checked:bg-accent dark:checked:before:bg-white"
                            type="checkbox"
                            checked={isInModalData}
                        />
                        <span>В модальном окне</span>
                    </label>
                </div>

                <div className={"w-3/12 ml-4 flex"}>
                    <label className="inline-flex items-center space-x-2">
                        <input
                            onChange={() => setTitleHideData(!isTitleHideData)}
                            className="form-switch h-5 w-10 rounded-full bg-slate-300 before:rounded-full before:bg-slate-50 checked:bg-primary checked:before:bg-white dark:bg-navy-900 dark:before:bg-navy-300 dark:checked:bg-accent dark:checked:before:bg-white"
                            type="checkbox"
                            checked={isTitleHideData}
                        />
                        <span>Скрывать заголовок</span>
                    </label>
                </div>

            </div>
            <div className={"mt-6"}>
                <Radio.Group
                    onChange={(e) => setCustomType(e.target.value)}
                    value={customType}
                    options={[
                        {
                            value: 'default',
                            label: (
                                <Flex gap="small" justify="center" align="center" vertical>
                                    <StopOutlined style={{fontSize: '30px', color: 'grey'}}/>
                                </Flex>
                            ),
                        },
                        {
                            value: 'html',
                            label: (
                                <Flex gap="small" justify="center" align="center" vertical>
                                    <IconMaterial type={'html'}/>
                                </Flex>
                            ),
                        },
                        {
                            value: 'text',
                            label: (
                                <Flex gap="small" justify="center" align="center" vertical>
                                    <IconMaterial type={'text'}/>
                                </Flex>
                            ),
                        },
                        {
                            value: 'pdf',
                            label: (
                                <Flex gap="small" justify="center" align="center" vertical>
                                    <IconMaterial type={'pdf'}/>
                                </Flex>
                            ),
                        },
                        {
                            value: 'image',
                            label: (
                                <Flex gap="small" justify="center" align="center" vertical>
                                    <IconMaterial type={'image'}/>
                                </Flex>
                            ),
                        },
                        {
                            value: 'video',
                            label: (
                                <Flex gap="small" justify="center" align="center" vertical>
                                    <IconMaterial type={'video'}/>
                                </Flex>
                            ),
                        },
                        {
                            value: 'slideshow',
                            label: (
                                <Flex gap="small" justify="center" align="center" vertical>
                                    <IconMaterial type={'slideshow'}/>
                                </Flex>
                            ),
                        },
                        {
                            value: 'testing',
                            label: (
                                <Flex gap="small" justify="center" align="center" vertical>
                                    <IconMaterial type={'testing'}/>
                                </Flex>
                            ),
                        },
                        {
                            value: 'file',
                            label: (
                                <Flex gap="small" justify="center" align="center" vertical>
                                    <IconMaterial type={'file'}/>
                                </Flex>
                            ),
                        }
                    ]}
                />
            </div>
            <div className={"mt-3"}>
                {type === 'html' &&
                    <FormHtml onSuccess={onSuccessRequest} value={contentData} setContentData={setContentData}
                              setEditor={setEditor}/>}
                {(type === 'text' || type === 'code') &&
                    <FormText onSuccess={onSuccessRequest} value={contentData} setContentData={setContentData}/>}
                {(type === 'file') &&
                    <FormFile onSuccess={onSuccessRequest} value={contentData} setContentData={setContentData}/>}
                {(type === 'slideshow') &&
                    <FormSlideshow onSuccess={onSuccessRequest} value={contentData} setContentData={setContentData}/>}
            </div>
            <div className={"mt-3"}>
                <Button type={"primary"} onClick={() => sendDataForm()} text={"Сохранить"}/>
            </div>
        </>}
    />
}

export default MaterialCreateFormModal;
